import "./scss/index.scss";
import AppRouter from "router";
import {
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "firebaseConfig";
import themeState from "states/themeEventTarget";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "queryClient";

export const startDay = "15 Тамыз";

const App = () => {
  const [mode, setMode] = useState<any>(themeState.theme)

  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode: mode
      }
    })
  }, [mode])

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("firebase user", user);
        if (user) {
          const idToken = await user.getIdToken();
        }
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  useEffect(() => {
    if (themeState.theme) {
      document.querySelector('html')?.setAttribute('data-theme', themeState.theme)
      setMode(themeState.theme)
    }

    themeState.addEventListener('theme', (e) => {
      if (e instanceof CustomEvent) {
        console.log("storage:", e.detail);
        document.querySelector('html')?.setAttribute('data-theme', e.detail)
        setMode(e.detail)
      }
    })
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
